// extracted by mini-css-extract-plugin
export default {"header":"suggestions_header__PqAla","content":"suggestions_content__7u21w","accontSelect":"suggestions_accontSelect__UYcYV"};